import {createRouter, createWebHistory} from 'vue-router'

import login from '@/pages/login/login'
import loginCode from '@/pages/login/loginCode'
import admin from '@/pages/admin'
import home from '@/pages/home/home'
import clinictreat from '@/pages/clinictreat/index'
import treatment from '@/pages/treatment/index'
import reservation from '@/pages/reservation/index'
import patient from '@/pages/patient/index'
import patientlist from '@/pages/patientlist/index'
import performance from '@/pages/performance/index'
import prescription from '@/pages/prescription/index'
import personal from '@/pages/personal/index'
import order from '@/pages/order/index'
import detail from '@/pages/order/detail'
import treatorder from '@/pages/treatorder/index'
import consultationcall from '@/pages/consultationcall/index'

let router = createRouter({
    // url 地址的转发规则
    history: createWebHistory(),
    // 在routes 中配置路由规则
    routes: [
        {path: '/', component: login, meta: {title: '欢迎登录知夏中医诊所'}},
        {path: '/login', component: login, meta: {title: '欢迎登录知夏中医诊所'}},
        {path: '/loginCode', component: loginCode, meta: {title: '知夏中医诊所短信登录'}},
        {path: '/admin', component: admin, meta: {title: '知夏中医诊所'},
            redirect: '/admin/home',
            children: [
                {path: 'home', name: 'home', component: home, meta: {title: '工作台'}},
                {path: 'clinictreat', name: 'clinictreat', component: clinictreat, meta: {title: '门诊接诊'}},
                {path: 'treatment', name: 'treatment', component: treatment, meta: {title: '检查治疗'}},
                {path: 'reservation', name: 'reservation', component: reservation, meta: {title: '预约管理'}},
                {path: 'patient', name: 'patient', component: patient, meta: {title: '病例管理'}},
                {path: 'patientlist', name: 'patientlist', component: patientlist, meta: {title: '病例管理'}},
                {path: 'performance', name: 'performance', component: performance, meta: {title: '绩效分析'}},
                {path: 'prescription', name: 'prescription', component: prescription, meta: {title: '处方模版'}},
                {path: 'personal', name: 'personal', component: personal, meta: {title: '个人中心'}},
                {path: 'order', name: 'order', component: order, meta: {title: '门诊订单'}},
                {path: 'detail', name: 'detail', component: detail},
                {path: 'treatorder', name: 'treatorder', component: treatorder, meta: {title: '诊疗工单'}},
                {path: 'consultationcall', name: 'consultationcall', component: consultationcall, meta: {title: '叫号问诊'}},
            ]
        },
    ]
});
export default router;
